import React from "react";

const Card = (props) => {
  return <div className="wrapper">{props.children}</div>;
};

export default Card;
